<template>
	<div>
		<v-member-events-list ref="eventsList" @event-edit="editEvent($event)"></v-member-events-list>
	</div>
</template>

<script>
	export default {
		data: function () {
			return {
				addMode: false,
				currentEvent: null
			}
		},

		methods: {
			showNewEventForm() {
				this.addMode = true;
			},

			hideNewEventForm() {
				this.addMode = false;
				this.currentEvent = null;
			},

			reloadEvents() {
				this.addMode = false;
				this.currentEvent = null;
				this.$refs.eventsList.getClubEvents();
			},

			editEvent(event) {
				this.addMode = true;
				this.currentEvent = event;
			}
		}
	}
</script>
